export default "__VITE_ASSET__DgikeEqu__"